let loadScript = function (url) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = url;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

let loadLinktree = async function (profile_path, utm_channel, selector) {
  await loadScript('https://assets.production.linktr.ee/sdk/js/AddThisButton.js');
  if (typeof linktree !== 'undefined') {
    window.linktree.AddThisButton.render(
      {
        link: {
          url: `${import.meta.env['VITE_SITE_URL']}${profile_path}`,
          title: 'Check out my recommendations on Benable!',
          utm_channel: utm_channel,
        },
      },
      selector
    );
  }
};

export default loadLinktree;
